// AI writing assistant (package flag `ai_writing`): the button in the editors and the Settings card.
export const aiEn = {
  'ai.button': 'Write with AI',
  'ai.title': 'AI writing assistant',
  'ai.field': 'Field: {field}',
  'ai.action.draft': 'Draft',
  'ai.action.improve': 'Improve writing',
  'ai.action.shorten': 'Shorten',
  'ai.action.expand': 'Expand',
  'ai.action.translate': 'Translate to {language}',
  'ai.tone': 'Tone',
  'ai.tone.formal': 'Formal',
  'ai.tone.casual': 'Casual',
  'ai.brief': 'What should it say?',
  'ai.briefHint': 'A few words or bullet points. The AI does not invent prices, certifications or client names; it leaves [fill in: …] placeholders instead.',
  'ai.sourceEmpty': 'This field is empty. Use Draft, or write something first.',
  'ai.sourceTooLong': 'The text is longer than {max} characters. Shorten it first.',
  'ai.generate': 'Generate',
  'ai.generating': 'Writing…',
  'ai.result': 'Result',
  'ai.resultHint': 'Check the result before using it and fill in every [fill in: …] placeholder.',
  'ai.truncated': 'The answer reached the length limit and may be cut off.',
  'ai.insert': 'Insert',
  'ai.replace': 'Replace',
  'ai.translationTarget': 'Goes into the {language} version of this field.',
  'ai.applied': 'Text applied. Review it, then save.',
  'ai.remaining': '{count} requests left today',
  'ai.noKey': 'No Anthropic API key is set for this site yet.',
  'ai.noKeyAdmin': 'Add it in Settings',
  'ai.noKeyEditor': 'Ask an administrator to add it in Settings.',
  'ai.locked': 'The AI writing assistant is available from the Advanced plan. Upgrade your plan or contact us.',
  'ai.lockedShort': 'Available from the Advanced plan',
  'ai.contact': 'Contact {email}',
  'ai.settings.title': 'AI writing assistant',
  'ai.settings.description': 'Claude Haiku drafts and edits copy in the editors. It uses your own Anthropic API key, so usage is billed to your Anthropic account.',
  'ai.settings.key': 'Anthropic API key',
  'ai.settings.keyHint': 'console.anthropic.com → API keys → Create key. Stored encrypted and never shown again.',
  'ai.settings.save': 'Save key',
  'ai.settings.saved': 'AI writing settings saved',
  'ai.settings.usageMonth': 'Usage this month',
  'ai.settings.requests': '{count} requests',
  'ai.settings.tokens': '{input} input tokens · {output} output tokens',
  'ai.settings.today': 'Today: {count} of {limit} requests',
  'ai.settings.limits': 'Limits: {daily} requests per day for the site, {perUser} per person per minute, up to {chars} characters in and {maxTokens} tokens out per request.',
  'ai.settings.model': 'Model: {model}',
} as const

export const aiId: Record<keyof typeof aiEn, string> = {
  'ai.button': 'Tulis dengan AI',
  'ai.title': 'Asisten penulisan AI',
  'ai.field': 'Kolom: {field}',
  'ai.action.draft': 'Buat draf',
  'ai.action.improve': 'Perbaiki tulisan',
  'ai.action.shorten': 'Persingkat',
  'ai.action.expand': 'Perpanjang',
  'ai.action.translate': 'Terjemahkan ke {language}',
  'ai.tone': 'Gaya bahasa',
  'ai.tone.formal': 'Formal',
  'ai.tone.casual': 'Santai',
  'ai.brief': 'Tulis tentang apa?',
  'ai.briefHint': 'Beberapa kata atau poin. AI tidak mengarang harga, sertifikasi, atau nama klien; bagian itu diberi penanda [isi: …].',
  'ai.sourceEmpty': 'Kolom ini masih kosong. Gunakan Buat draf, atau tulis sesuatu dulu.',
  'ai.sourceTooLong': 'Teks lebih dari {max} karakter. Persingkat dulu.',
  'ai.generate': 'Buat',
  'ai.generating': 'Sedang menulis…',
  'ai.result': 'Hasil',
  'ai.resultHint': 'Periksa hasilnya sebelum dipakai dan lengkapi setiap penanda [isi: …].',
  'ai.truncated': 'Jawaban mencapai batas panjang dan mungkin terpotong.',
  'ai.insert': 'Sisipkan',
  'ai.replace': 'Ganti',
  'ai.translationTarget': 'Masuk ke versi {language} kolom ini.',
  'ai.applied': 'Teks diterapkan. Periksa, lalu simpan.',
  'ai.remaining': 'Sisa {count} permintaan hari ini',
  'ai.noKey': 'Kunci API Anthropic untuk situs ini belum diisi.',
  'ai.noKeyAdmin': 'Isi di Pengaturan',
  'ai.noKeyEditor': 'Minta administrator mengisinya di Pengaturan.',
  'ai.locked': 'Asisten penulisan AI tersedia mulai paket Advanced. Upgrade paket atau hubungi kami.',
  'ai.lockedShort': 'Tersedia mulai paket Advanced',
  'ai.contact': 'Hubungi {email}',
  'ai.settings.title': 'Asisten penulisan AI',
  'ai.settings.description': 'Claude Haiku membantu membuat draf dan menyunting teks di editor. Asisten memakai kunci API Anthropic milik Anda, jadi biaya pemakaian ditagihkan ke akun Anthropic Anda.',
  'ai.settings.key': 'Kunci API Anthropic',
  'ai.settings.keyHint': 'console.anthropic.com → API keys → Create key. Disimpan terenkripsi dan tidak pernah ditampilkan lagi.',
  'ai.settings.save': 'Simpan kunci',
  'ai.settings.saved': 'Pengaturan penulisan AI disimpan',
  'ai.settings.usageMonth': 'Pemakaian bulan ini',
  'ai.settings.requests': '{count} permintaan',
  'ai.settings.tokens': '{input} token masuk · {output} token keluar',
  'ai.settings.today': 'Hari ini: {count} dari {limit} permintaan',
  'ai.settings.limits': 'Batas: {daily} permintaan per hari untuk situs ini, {perUser} per orang per menit, maksimal {chars} karakter masuk dan {maxTokens} token keluar per permintaan.',
  'ai.settings.model': 'Model: {model}',
}
